import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import FormContentLoader from '../../../../../components/FormContentLoader';
import ENDPOINT from '../../../../../constants/endpoints';
import ERROR_FIELD from '../../../../../constants/error-fields';
import useApi from '../../../../../hooks/useApi';
import ResponseErrorDialog from '../../../../Dialog/components/ResponseErrorDialog';
import CandidateNotificationsSettings from './CandidateNotificationsSettings';

import './styles.css';

const NotificationsSection = props => {
  const { user } = props;
  const api = useApi();
  const [accountSettings, setAccountSettings] = useState(null);
  const [params, setParams] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getSettings = useCallback(() => {
    api.get(
      ENDPOINT.FORM.GET.ACCOUNT_SETTINGS,
      {},
      {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: formData => {
          setAccountSettings(formData.fields);
          setParams(formData.params);
          setIsLoading(false);
        },
      }
    );
  }, []);

  const updateCandidateSettings = useCallback(values => {
    const apiCall = new Promise((resolve, reject) => {
      api.post(
        ENDPOINT.FORM.SAVE.ACCOUNT_SETTINGS_CANDIDATE_NOTIFICATIONS,
        values,
        {
          handleError: response => {
            reject(response);
            onSubmitError(response);
          },
          handleSuccess: () => {
            resolve();
            getSettings();
          },
        }
      );
    });

    toast.promise(apiCall, {
      pending: {
        render() {
          return <p>Saving...</p>;
        },
        icon: false,
      },
      success: {
        render() {
          return <p>Your account data has been updated.</p>;
        },
        // other options
        icon: '🟢',
      },
      error: {
        render({ data }) {
          const {
            data: { fields },
          } = data;
          if (fields) {
            const obj = {};
            for (let [key, value] of Object.entries(fields)) {
              const error = isArray(value) ? value[0] : value;
              obj[key] = ERROR_FIELD[error] || `${error}`;
            }
            return Object.values(obj).join('<br />');
          } else {
            // When the promise reject, data will contain the error
            return `${data.status}`;
          }
        },
      },
    });
  }, []);

  useEffect(() => {
    getSettings();
  }, [getSettings]);

  const onSubmitError = response => {
    ResponseErrorDialog({ response });
  };

  if (isLoading) {
    return <FormContentLoader />;
  }

  return (
    <CandidateNotificationsSettings
      user={user}
      settings={accountSettings}
      params={params}
      onChange={values => {
        if (!isEqual(values, accountSettings)) {
          const {
            changeEmailRequestTo,
            EmailAddress,
            ...changedState
          } = values;
          updateCandidateSettings(changedState);
        }
      }}
    />
  );
};

export default NotificationsSection
